import {call, delay, put, takeLatest} from "redux-saga/effects"
import {ADD_KUNDEN_BATCH, addKundenBatchSuccessAction} from "../kundeAction";
import {importKunden} from "../../../api/kundenApi";
import {extractDataFromResponse} from "../../saga-utils/httpInterceptorWrapper";

function* processAddKundenBatch({payload}) {
    const {kunden} = payload
    yield delay(1500)
    try {
        const result = extractDataFromResponse(yield call(importKunden, {kunden}))
        yield put(addKundenBatchSuccessAction({success: result.processed, doublets: result.doublets, failed: []}))
    } catch (err) {
        console.log(err)
        yield put(addKundenBatchSuccessAction({success: 0, doublets: [], failed: kunden}))
    }
}

export function* watchAddKundenBatch() {
    yield takeLatest(ADD_KUNDEN_BATCH, processAddKundenBatch)
}